import z from "zod/v4";

/**
 * Branded type for date-only strings in YYYY-MM-DD format.
 */
export const isoDate = z.iso.date().brand("ISODate");

export type ISODate = z.output<typeof isoDate>;
